// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#are-svg path{stroke-dasharray:649.437;stroke-dashoffset:649.437;animation-name:drawbo;animation-delay:1.5s;animation-duration:4s;animation-timing-function:ease-out;animation-fill-mode:forwards}@keyframes drawbo{from{stroke-dashoffset:649.437}to{stroke-dashoffset:0}}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
